<template>
  <div>
    <div class="flex justify-between align-items-center mb-3">
      <div><h1>Manage Order</h1></div>
      <vs-button @click="goToOrders">Back to orders</vs-button>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-7/12 w-full">
        <!-- order status card -->
        <vx-card
          class="card mt-3 mb-3"
          title="Order Status"
          v-model="isSidebarActiveLocal"
        >
          <h6 class="mt-1 mb-1">Order ID: {{ orderData.orderId }}</h6>
          <div class="vx-row mb-3">
            <div class="col md:w-6/12 w-1/2 mt-3 px-3">
              <!-- updating order status -->
              <div v-show="!isEditing">
                <div class="flex justify-between align-items-center ">
                <vs-select
                  v-model="orderData.status"
                  label="Current Status"
                  class="w-full"
                  :disabled="!isEditing"
                >
                  <vs-select-item
                    :key="item.value"
                    :value="item.value"
                    :text="item.text"
                    v-for="item in status_choices"
                  />
                </vs-select>
                <!-- <vs-input v-model="orderStatus" :disabled="!isEditing"/> -->
                <feather-icon
                class="ml-2"
                  icon="EditIcon"
                  svgClasses="w-9 h-8 hover:text-primary stroke-current"
                  @click="eidtOrderStatus(orderData.status)"
                />
                </div>
              </div>
              <div v-show="isEditing" >
                 <div class="">
                <vs-select v-model="orderStatus" label="Current Status" class="w-full mb-2">
                  <vs-select-item                  
                    :key="item.value"
                    :value="item.value"
                    :text="item.text"
                    v-for="item in status_choices"
                  />
                </vs-select>
                <!-- <vs-input v-model="orderStatus"/> -->
                <vs-button @click="updateOrderStatus">Update status</vs-button>
                 </div>
              </div>
            </div>
          
            <!-- adding delivary date -->
            <div class="col md:w-1/2 w-1/2 mt-3">
              
              <div v-show="!isEditingDate">
                 <div class="flex justify-between align-items-center ">
                <div class="w-full">
                  <label>Update delivery date</label><br />
                <vs-input
                class="w-full"
                  v-model="orderData.deliveryDate"
                  :disabled="!isEditingDate"
                ></vs-input></div>
                <feather-icon
                class="ml-2"
                  icon="EditIcon"
                  svgClasses="w-9 h-8 hover:text-primary stroke-current"
                  @click="eidtdeliveryDate(orderData.deliveryDate)"
                />
                 </div>
              </div>
            
              <div v-show="isEditingDate">
                 <div class="">
                <div class="w-full"><label>Update delivery date</label><br />
                <date-picker class="w-full mb-2"
                  v-model="dataDeliveryDate"
                  valueType="format"
                ></date-picker></div>
                <vs-button @click="updateDeliveryDate">Update status</vs-button>
                 </div>
              </div>
            </div>
          </div>

          <!-- table for ordered products   -->
          <vs-table :data="orderedProducts">
            <template slot="thead">
              <!-- <vs-th sort-key="id">ID</vs-th> -->
              <vs-th sort-key="name">Product name</vs-th>
              <vs-th sort-key="price">Price (₹)</vs-th>
              <vs-th sort-key="quantity">Quantity</vs-th>
              <vs-th sort-key="Total price">Total Price (₹)</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td class="img-container">
                                    <img :src="orderedProducts.smallImgUrl" class="product-img" />
                                </vs-td> -->
                <vs-td>
                  {{ tr.name }}
                </vs-td>
                <vs-td>{{ tr.priceAmount }} </vs-td>
                <vs-td>{{ tr.qty }} </vs-td>
                <vs-td>{{ tr.priceAmount * tr.qty }} </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>

        <!-- payment status card -->
        <vx-card title="Payment Status">
          <h6>Status:  Completed</h6>
        </vx-card>
      </div>

      <div class="vx-col md:w-5/12 w-full">
        <!-- customer info card -->
        <vx-card class="mt-3 mb-3" title="Customer Details">
          <h6>Customer name: {{ orderData.address.userId.name }}</h6>
          <h6>Customer Email: {{ orderData.email }}</h6>
        </vx-card>

        <!-- shipping adress card -->
        <vx-card title="Shipping Adress">
          <h6>{{ orderData.address.placeName }},</h6>
          <h6>{{ orderData.address.street }},</h6>
          <h6>{{ orderData.address.area }},</h6>
          <h6>Landmark: {{ orderData.address.landMark }},</h6>
          <h6>City: {{ orderData.address.city }},</h6>
          <h6>Pincode: {{ orderData.address.pinCode }},</h6>
          <h6>
            Phone no: {{ orderData.address.countryCode }}
            {{ orderData.address.phone }},
          </h6>
          <h6>State: {{ orderData.address.state }}</h6>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DatePicker
  },

  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    orderData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isEditing: false,
      isEditingDate: false,
      orderStatus: null,

      status_choices: [
        { text: 'ORDERED', value: 'ORDERED' },
        { text: 'DISPATCHED', value: 'DISPATCHED' },
        { text: 'SHIPPED', value: 'SHIPPED' },
        { text: 'DELIVERED', value: 'DELIVERED' },
        { text: 'RETURNED', value: 'RETURNED' },
        { text: 'CANCELLED', value: 'CANCELLED' }
      ],
      dataDeliveryDate: null
    }
  },
  watch: {
    // isSidebarActive (val) {
    //   if (!val) return
    //   //   const {status} = JSON.parse(JSON.stringify(this.orderData))
    //   this.orderStatus = this.orderData.status
    //   console.log('status is here', status)

    // },
    orderStatus (val) {
      if (val) {
        this.orderData.status = this.orderStatus
      }
    },
    dataDeliveryDate (val) {
      if (val) {
        this.orderData.deliveryDate = this.dataDeliveryDate
      }
    }
  },
  computed: {
    orderedProducts () {
      const products = []
      products.push(this.orderData.product)
      return products
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    }
  },
  methods: {
    goToOrders () {
      this.$emit('closeSidebar')
    },
    editingMode () {
      this.isEditing = true
    },
    eidtOrderStatus (status) {
      this.isEditing = true
      this.orderStatus = status
    },
    eidtdeliveryDate (deliverydate) {
      this.isEditingDate = true
      this.dataDeliveryDate = deliverydate
    },
    updateOrderStatus () {
      this.isEditing = false
      const obj = {
        status: this.orderStatus,
        id: this.orderData._id
      }
      // console.log('update order obj', obj)
      this.$store.dispatch('orders/updateOrder', obj).catch((err) => {
        console.error(err)
      })
    },
    updateDeliveryDate () {
      this.isEditingDate = false
      const obj = {
        status: this.orderData.status,
        deliveryDate: this.dataDeliveryDate,
        id: this.orderData._id
      }
      // console.log('update order obj', obj)
      this.$store.dispatch('orders/updateOrder', obj).catch((err) => {
        console.error(err)
      })
    }
  }
}
</script>

